<template>
  <div class="content-box">
    <div v-for="(item, index) in videoes" :key="index">
      <div v-if="item.type == 'video'" class="videoItem">
        <video
          :src="item.data.videoUrl"
          :poster="item.data.videoUrl + '?vframe/jpg/offset/0/w/480'"
          alt
          controls="controls"
        ></video>
      </div>
      <div v-if="item.type == 'text'" class="text-item">
        <div v-html="item.data">{{ item.data }}</div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    shareInfo: Object
  },
  computed: {
    videoes() {
      return JSON.parse(this.shareInfo.activityTemplet || "[]");
    }
  }
};
</script>
        
<style scoped>
video {
  width: 100%;
}
</style>
